import { useMutation } from '@apollo/client'
import { Stack } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { SetFavoriteCandidate } from 'client/graphql/favorites.gql'
import { useIdentity } from 'client/hooks'
import FavoriteButton from 'shared/components/favoriteButton'
import useToast from 'shared/components/Toast/useToast'

export default function ClientPortalActionsCell(params: GridRenderCellParams) {
    const identity = useIdentity()
    const toast = useToast()
    const [updateFavorite] = useMutation(SetFavoriteCandidate)

    const isSelected = params.row.clientFavorites?.some(
        (favorite: { clientId: string }) =>
            favorite.clientId === identity?.client?.id
    )
    const count = params.row.rosterCandidateFavoriteCount ?? 0

    return (
        <Stack
            direction="row"
            height="100%"
            justifyContent="start"
            alignItems="center"
            spacing={1}
        >
            <FavoriteButton
                isSelected={isSelected}
                count={count}
                disabled={!identity?.client}
                onClick={(isSelected) =>
                    updateFavorite({
                        variables: {
                            rosterCandidateId: params.row.rosterCandidateId,
                            isFavorited: isSelected,
                        },
                        onCompleted: (data) => {
                            if (!data.updateFavorite.success) {
                                toast({
                                    severity: 'error',
                                    title: 'Error updating favorite candidate',
                                    message:
                                        data.updateFavorite.message ??
                                        'no message',
                                })
                                console.error(data.updateFavorite.message)
                            } else {
                                toast({
                                    severity: 'success',
                                    title: 'Success',
                                    message: 'Candidate updated',
                                })
                            }
                        },
                        onError: (error) => {
                            toast({
                                severity: 'error',
                                title: 'Error updating favorite candidate',
                                message: error.message,
                            })
                            console.error(error)
                        },
                        refetchQueries: ['GetCandidatesForClientPortalSql'],
                    })
                }
            />
        </Stack>
    )
}
